<template>
    <div>
      学习中心


      <Footer></Footer>
    </div>
</template>

<script>
    import Footer from "../components/Footer";
    export default {
        name: "Study",
      components: {Footer}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Study.vue